export enum ModalContent {
  Under19,
  Between26and29,
  ThirtyAndOver,
  Over65,
  PlanNotFound,
  LifeEvent,
  SubmissionError,
  Empty,
  EffectiveDateError,
  CannotRetrieveBenefitsSummary
}